import Vue from 'vue'
import VueRouter from 'vue-router'
import LightBootstrap from './light-bootstrap-main'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import jsProto from './jsProto.js'
var config = require('../config')
// Plugins
import App from './App.vue'

// router setup
import routes from './routes/routes'

Axios.defaults.baseURL ="https://licencias.solutechn.com/sistema/modules/include"

// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)
Vue.use(VueAxios, Axios)


// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

Vue.axios.interceptors.response.use((response) => {
  return response;
}, function (error) {
  if(error.response.status === 403){
   window.location.href = '#/logout'
  } else {
    return Promise.reject(error);
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})

